import literalsService from '../../services/literals-service'
import { IConfigurationState } from '../states'
import { ConfigurationActionTypes, ConfigurationTypeKeys } from '../types'

export const initialConfigurationState: IConfigurationState = {
  language: literalsService.getInitialLanguage(),
  areas: [],
  selectedAreaId: null,
  isFetchingAreas: false,
  clientInfo: null,
  areaChanged: false,
  showPaymentMethod: false
}

const configuration = (
  state: IConfigurationState = initialConfigurationState,
  action: ConfigurationActionTypes
): IConfigurationState => {
  switch (action.type) {
    case ConfigurationTypeKeys.FETCHING_AREAS:
      return { ...state, isFetchingAreas: true }
    case ConfigurationTypeKeys.CHANGE_LANGUAGE:
      return { ...state, language: action.payload }
    case ConfigurationTypeKeys.FETCH_AREAS_SUCCESSFUL:
      return {
        ...state,
        isFetchingAreas: false,
        areas: action.payload
      }
    case ConfigurationTypeKeys.FETCH_CLIENT_INFO_SUCCESSFUL:
      return { ...state, clientInfo: action.payload }
    case ConfigurationTypeKeys.SET_SELECTED_AREA:
      return {
        ...state,
        selectedAreaId: action.payload
      }
    case ConfigurationTypeKeys.SET_AREA_CHANGED:
      return {
        ...state,
        areaChanged: true
      }
    case ConfigurationTypeKeys.RESET_AREA_CHANGED:
      return {
        ...state,
        areaChanged: false
      }
    case ConfigurationTypeKeys.SET_STRIPE:
      return {
        ...state,
        stripe: action.payload
      }
    case ConfigurationTypeKeys.SET_SHOW_PAYMENT_METHOD:
      return {
        ...state,
        showPaymentMethod: action.payload
      }
    default:
      return state
  }
}

export default configuration
